import { RunningEvent } from '../types';

// Citations object for reference management (same as English)
export const CITATIONS_DE = {
  1: {
    title: 'Time to correct the record on the global burden of myalgic encephalomyelitis/chronic fatigue syndrome (ME/CFS)',
    authors: 'Vardaman M, Gilmour S',
    journal: 'Journal of Translational Medicine',
    year: '2025',
    url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11907965/',
    doi: '10.1186/s12967-025-06281-0'
  },
  2: {
    title: 'Economic Impact Report: Long COVID and ME/CFS',
    authors: 'ME/CFS Research Foundation',
    year: '2024',
    url: 'https://mecfs-research.org/costreport-long-covid-and-mecfs/'
  },
  3: {
    title: 'ME/CFS Funding Report',
    authors: 'ME Research UK',
    year: '2016',
    url: 'https://www.meresearch.org.uk/mecfs-funding-report/'
  },
  4: {
    title: 'Health-related quality of life in patients with chronic fatigue syndrome: an international study',
    authors: 'Nacul LC, Lacerda EM, Pheby D, et al.',
    journal: 'PLOS ONE',
    year: '2011',
    url: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0132421',
    doi: '10.1371/journal.pone.0132421'
  },
  5: {
    title: 'Ärzteblatt Report: Long COVID and ME/CFS costs society 63 billion euros annually',
    authors: 'Deutsches Ärzteblatt',
    year: '2024',
    url: 'https://www.aerzteblatt.de/news/medienbericht-long-covid-und-mecfs-kosten-gesellschaft-63-milliarden-euro-jahrlich-ac6ab36c-b2e4-40a1-8f27-6b52d53dd9e8'
  },
  6: {
    title: 'BMBF Forschungsfinanzierung für ME/CFS',
    authors: 'ME/CFS Research Foundation',
    year: '2023',
    url: 'https://mecfs-research.org/en/bmbf-researchfunding-sep23/'
  },
  7: {
    title: 'Characterization of Post-exertional Malaise in Patients With Myalgic Encephalomyelitis/Chronic Fatigue Syndrome',
    authors: 'Stussman B, Williams A, Snow J, et al.',
    journal: 'Frontiers in Neurology',
    year: '2020',
    url: 'https://www.frontiersin.org/articles/10.3389/fneur.2020.01025/full',
    doi: '10.3389/fneur.2020.01025'
  },
  8: {
    title: 'Long COVID and ME/CFS: A systematic review and meta-analysis',
    authors: 'Multiple authors',
    journal: 'Journal of Infection',
    year: '2024',
    url: 'https://linkinghub.elsevier.com/retrieve/pii/S0163445324002317',
    doi: '10.1016/j.jinf.2024.01.001'
  }
};

export const ME_INFO_DE = {
  title: 'Was ist M.E.?',
  description: "Myalgische Enzephalomyelitis (M.E.) ist eine komplexe, neuroimmunologische, chronische Erkrankung, die etwa 71 Millionen Menschen weltweit betrifft¹, allein in Deutschland 650.000+⁵, wobei viele Fälle undiagnostiziert bleiben. \n Diese Krankheit wird häufig durch eine Virusinfektion ausgelöst. Die genauen Ursachen der Krankheit sind bislang unzureichend verstanden, jedoch konnten bereits verschiedene Funktionsstörungen des Nervensystems, des endokrinen Systems, des Immunsystems und anderer Systeme und Organe identifiziert werden. \n M.E kann so stark einschränkend verlaufen, dass Betroffenen grundlegende Fähigkeiten wie Essen, Sprechen verlieren. Auch Licht- und Geräuschempfindlichkeit sind häufig, in schweren Fällen führt M.E zur vollständigen Bettlägerigkeit. \n Obwohl sie Millionen weltweit betrifft und eine der schwersten chronischen Erkrankungen ist, bleibt M.E. stark missverstanden, unterfinanziert und wird oft von Gesundheitsdienstleistern abgetan.",
  keyFacts: {
    title: 'Wichtige Fakten',
    description: 'Die grundlegenden Aspekte dieser komplexen Erkrankung verstehen',
    cards: [
      {
        icon: 'People',
        title: 'Globale Auswirkungen',
        description: 'Betrifft etwa 71 Millionen Menschen weltweit¹, wobei viele Fälle undiagnostiziert bleiben.',
      },
      {
        icon: 'Virus',
        title: 'Virale Auslöser',
        description: 'Wird oft durch Virusinfektionen ausgelöst, einschließlich COVID-19, Epstein-Barr-Virus und anderen Erregern.',
      },
      {
        icon: 'Health',
        title: 'Schwere Behinderung',
        description: 'Kann Patienten vollständig bettlägerig machen, unfähig grundlegende tägliche Aktivitäten durchzuführen.',
      },
    ],
  },
  pemDescription: ' Post-exertionale neuroimmune Erschöpfung (PENE) ist das Kardinalsymptom von M.E.⁷ - es bedeutet eine Verschlechterung der Symptome nach selbst minimaler körperlicher oder geistiger Anstrengung. Dies kann Tage, Wochen oder sogar Monate dauern und macht es Patienten unmöglich, normale Aktivitätsniveaus aufrechtzuerhalten.',
  whyThisMatters: {
    title: 'Warum M.E. Aufklärung wichtig ist',
    description: 'Das Verständnis von M.E. ist von entscheidender Bedeutung, da es Millionen von Menschen weltweit betrifft, und die Erkrankung weitgehend missverstanden und unterfinanziert ist. Für Betroffene bedeutet M.E. nicht nur eine massive gesundheitliche Einschränkung, sondern auch ein Mangel an gesellschaftlichem und medizinischem Verständnis. Trotz der Schwere der Krankheit wird M.E. häufig von Gesundheitsfachkräften nicht ernst genommen und bleibt unterfinanziert. Durch die Unterstützung von Forschung und Aufklärung können wir dazu beitragen, das Leben der Betroffenen zu verbessern und eine Zukunft mit besseren Behandlungsmöglichkeiten zu schaffen.',
  },
  symptoms: {
    title: 'Symptome',
    pemTitle: '⚠️ Post-exertionale neuroimmune Erschöpfung (PENE) - Das Kardinalsymptom',
    otherSymptomsTitle: 'Weitere Symptome',
    list: [
      'Muskelschwäche',
      'Grippeähnliche Erschöpfung',
      'Nicht erholsamer Schlaf',
      'Schmerzen in Muskeln, Gelenken oder Nerven',
      'Funktionsstörungen der kognitiven Funktionen (Gehirnnebel)',
      'Orthostatische Intoleranz (Schwierigkeiten beim Aufstehen aus liegender oder sitzender Position)',
      'Überempfindlichkeit gegenüber Licht, Geräuschen und anderen Reizen',
    ],
  },
  economicImpact: {
    title: 'Wirtschaftliche Auswirkungen',
    description: 'M.E. und Long COVID zusammen haben große wirtschaftliche Auswirkungen in Deutschland und kosten etwa 63 Milliarden Euro jährlich². Von dieser Gesamtsumme entfallen etwa die Hälfte auf M.E. Dies umfasst Gesundheitskosten, Produktivitätsverluste und die Belastung für Familien und Pflegekräfte. Ähnliche wirtschaftliche Auswirkungen wurden in anderen Ländern festgestellt, wobei Studien vergleichbare Belastungen relativ zum BIP zeigen.',
    source: 'https://mecfs-research.org/costreport-long-covid-and-mecfs/',
    study: {
      id: 'economicImpact',
      title: 'Wirtschaftliche Auswirkungen in Deutschland nach Jahr',
      data: [
        { year: '2022', cost: '58 Milliarden €', gdpImpact: 1.4 },
        { year: '2023', cost: '61 Milliarden €', gdpImpact: 1.5 },
        { year: '2024', cost: '63 Milliarden €', gdpImpact: 1.5 },
        { year: '2025 (geschätzt)', cost: '65 Milliarden €', gdpImpact: 1.6 },
      ],
      source: 'https://mecfs-research.org/costreport-long-covid-and-mecfs/',
      buttonText: 'Studie ansehen',
    },
  },
  researchFunding: {
    title: 'Forschungsfinanzierungslücke',
    description: 'Die derzeitige öffentliche Forschungsfinanzierung für M.E. ist weltweit extrem niedrig. 2006-2016 waren es global nur etwa 54 Millionen Euro³. An der Situation hat sich bisher wenig geändert. Zum Beispiel finanziert Deutschland derzeit "nur" 15 Millionen Euro für ein 3-jähriges M.E. Forschungsprogramm⁶. Dem steht die massive wirtschaftliche Belastung entgegen, die diese Krankheit verursacht. Allein in Deutschland kosten M.E. und Long COVID zusammen etwa 63 Milliarden Euro jährlich², wobei M.E. etwa die Hälfte ausmacht. Die Forschungsfinanzierungslücke bleibt enorm, und dieser Finanzierungsmangel hat den Fortschritt beim Verständnis der Krankheit und der Entwicklung wirksamer Behandlungen erheblich verlangsamt.',
    source: 'https://www.meresearch.org.uk/mecfs-funding-report/',
    study: {
      id: 'researchFunding',
      title: 'Vergleich der Forschungsfinanzierung (Daten von 2006-2016)',
      data: [
        { condition: 'Epilepsie', funding: 1840, unit: 'Millionen €' },
        { condition: 'Rheumatoide Arthritis', funding: 1495, unit: 'Millionen €' },
        { condition: 'Multiple Sklerose', funding: 1265, unit: 'Millionen €' },
        { condition: 'ADHS', funding: 608, unit: 'Millionen €' },
        { condition: 'Migräne', funding: 248, unit: 'Millionen €' },
        { condition: 'Ataxia Telangiectasia', funding: 85, unit: 'Millionen €' },
        { condition: 'M.E./CFS', funding: 54, unit: 'Millionen €' },
      ],
      source: 'https://www.meresearch.org.uk/mecfs-funding-report/',
      buttonText: 'Forschung ansehen',
    },
  },
  mostDisabling: {
    title: 'M.E. - Eine der stärksten einschränkenden chronischen Erkrankungen',
    description: 'M.E. zählt zu den am stärksten einschränkenden chronischen Erkrankungen. Viele Betroffene erleben eine geringere Lebensqualität als bei Menschen mit Multipler Sklerose, Krebs oder Herzkrankheiten⁴. Mit M.E. zu leben bedeutet, mit ständigen Schmerzen und anderen Symptomen zu leben. Patienten im schweren Spektrum sind oft vollständig bettlägerig, unfähig, sich selbst zu versorgen, und beschreiben ihr Leben als "lebendig begraben".',
    source: 'https://mecfs-research.org/researchfunding-munich/',
    study: {
      id: 'healthIndex',
      title: 'Gesundheitsindex-Vergleich',
      explanation: 'Der EQ-5D 3L ist ein standardisiertes Maß, das körperliches, geistiges und soziales Wohlbefinden bewertet. Werte unter 0,5 zeigen eine signifikante gesundheitliche Beeinträchtigung an, während Werte über 0,7 einen relativ guten Gesundheitszustand darstellen.',
      data: [
        { condition: 'ME/CFS', score: 0.47 },
        { condition: 'COPD', score: 0.65 },
        { condition: 'Multiple Sklerose', score: 0.67 },
        { condition: 'Rheumatoide Arthritis', score: 0.69 },
        { condition: 'Lungenkrebs', score: 0.69 },
        { condition: 'Schlaganfall', score: 0.71 },
        { condition: 'Diabetes Typ II', score: 0.72 },
        { condition: 'Darmkrebs', score: 0.74 },
        { condition: 'Allgemeine Bevölkerung', score: 0.85 },
      ],
      source: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0132421',
      buttonText: 'Studie ansehen',
    },
  },
  prevalence: {
    title: 'M.E. - Eine häufige, aber unsichtbare Erkrankung',
    description: 'Obwohl M.E. in der öffentlichen Wahrnehmung kaum präsent ist, ist diese Erkrankung überraschend häufig. M.E. betrifft schätzungsweise ~71 Millionen Menschen weltweit¹, was etwa 0,9% der Weltbevölkerung entspricht. Dies macht sie häufiger als viele bekannte Erkrankungen, doch sie erhält weit weniger Aufmerksamkeit und Finanzierung.',
    globalStats: {
      title: 'Globale Prävalenz',
      data: [
        { region: 'Weltweit', cases: '~71 Millionen', percentage: '0,9%' },
        { region: 'Vereinigte Staaten', cases: '3-4 Millionen', percentage: '1-1,2%' },
        { region: 'Deutschland', cases: '~650.000', percentage: '0,8%' },
      ],
    },
    underdiagnosis: {
      title: 'Die versteckte Prävalenz',
      description: 'Diese Zahlen repräsentieren wahrscheinlich nur einen Bruchteil der tatsächlichen Prävalenz, da M.E. notorisch unterdiagnostiziert ist. Viele Betroffene werden mit Depressionen, Angstzuständen oder anderen Erkrankungen fehldiagnostiziert, während andere nie eine Diagnose erhalten. Die tatsächliche Anzahl der Betroffenen könnte deutlich höher sein.',
    },
    sources: [
      {
        name: 'Deutschland - Ärzteblatt Bericht',
        url: 'https://www.aerzteblatt.de/news/medienbericht-long-covid-und-mecfs-kosten-gesellschaft-63-milliarden-euro-jahrlich-ac6ab36c-b2e4-40a1-8f27-6b52d53dd9e8',
      },
      {
        name: 'US - NIH ME/CFS Forschung',
        url: 'https://www.nih.gov/advancing-mecfs-research',
      },
      {
        name: 'Global - NIH ME/CFS Studie',
        url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11907965/',
      },
    ],
  },
  longCovid: {
    title: 'Long COVID & M.E.',
    statement: 'Studien deuten darauf hin, dass nach etwa einem halben Jahr Erkrankungsdauer circa die Hälfte der Long-COVID-Betroffenen die Diagnosekriterien für M.E. erfüllt⁸.',
    description: 'M.E. ist die schwerste Form von Long COVID, aber COVID-19 ist nur einer von vielen Auslösern von M.E..',
    keyPoints: [
      'M.E. ist die schwerste Form von Long COVID',
      'COVID-19 ist nur einer von vielen viralen Auslösern',
      'Andere Auslöser sind Epstein-Barr-Virus, Enteroviren, Herpes-Viren',
      'Der zugrunde liegende Krankheitsmechanismus ist unabhängig vom Auslöser identisch',
      'M.E. wurde bereits Jahrzehnte vor COVID-19 dokumentiert',
    ],
  },
  livingWithME: {
    title: 'Was bedeutet es, mit M.E. zu leben?',
    description: 'Mit M.E. zu leben bedeutet, nicht nur unter schweren gesundheitlichen Einschränkungen zu leiden, sondern auch einem Gesundheitssystem gegenüberzustehen, das die Krankheit oft nicht erkannt, versteht oder ernst nimmt. Viele Betroffene kämpfen darum, überhaupt medizinische Unterstützung zu erhalten. Qualifizierte Anlaufstellen sind rar, wirksame Behandlungen sind bisher kaum verfügbar oder befinden sich noch im experimentellen Stadium.',
    stages: [
      {
        severity: 'Mildes',
        description: 'Symptome schränken das tägliche Leben bereits erheblich ein und lassen Betroffene nur mit einem Bruchteil ihres vorherigen Leistungsniveaus zurück. Teilzeitarbeit ist möglich, aber Betroffene müssen auf Freizeitaktivitäten verzichten und erleben schwere Einschränkungen im sozialen Leben. Ihre Einschränkungen sind oft schwer für andere zu verstehen.',
      },
      {
        severity: 'Moderates',
        description: 'Betroffene sind hausgebunden aufgrund schwerer Symptome. Unfähig zu arbeiten und auf Hilfe bei Haushaltsaufgaben angewiesen. Können nur für begrenzte Zeit stehen und nur kurze Strecken gehen. Mobilitätshilfen wie Rollstühle können die Lebensqualität verbessern, aber Versicherungen verweigern oft die finanzielle Unterstützung.',
      },
      {
        severity: 'Schweres',
        description: 'Meist bettlägerig und benötigen intensive Hilfe bei grundlegenden täglichen Aktivitäten und persönlicher Hygiene. Können sich nur für sehr kurze Zeit konzentrieren und sensorische Reize (Licht, Lärm, Berührung) nur kurz tolerieren. Viele haben kaum Zugang zu medizinischer Versorgung, da wenige Ärzte Hausbesuche machen.',
      },
      {
        severity: 'Sehr schweres',
        description: 'Können keine sensorischen Reize (Licht, Lärm, Berührung) aushalten und müssen abgeschirmt in abgedunkelten, stillen Räumen liegen. Benötigen rundum die Uhr Pflege und manchmal künstliche Ernährung. Unter den schwerstkranken Menschen. Es gibt einen kritischen Mangel an ausreichend ausgebildetem Pflegepersonal.',
      },
    ],
  },
  impactOnPatients: {
    title: 'Auswirkungen auf Patienten',
    description: 'M.E. betrifft etwa 71 Millionen Menschen weltweit¹, wobei viele Fälle undiagnostiziert bleiben. Die Erkrankung kann schwer behindernd sein und viele Patienten bettlägerig oder hausgebunden machen.',
    additionalInfo: 'Viele Betroffene stoßen im Gesundheitssystem auf Unglauben und kämpfen darum, eine angemessene medizinische Versorgung zu erhalten. Häufig werden sie fehldiagnostiziert. Der Mangel an Verständnis und Forschungsfinanzierung bedeutet, dass die meisten Behandlungen experimentell oder nicht verfügbar sind.',
    familyImpact: 'Familien und Pflegekräfte tragen auch eine enorme Belastung, sowohl emotional als auch finanziell, während sie geliebte Menschen unterstützen, die vollständig bettlägerig sein oder ständige Pflege benötigen können.',
  },
};

export const FUNDRAISER_INFO_DE = {
  title: 'Unsere Mission',
  description: 'Angefangen haben wir zu dritt. Heute tragen über 300 Menschen unser Trikot — bei Marathons, Trailruns, Firmenläufen und auf einer Runde im Park, in Deutschland, Österreich und quer durch Europa, um M.E. bekannt zu machen und Spenden zu sammeln.',
  description_short: 'Angefangen haben wir zu dritt. Heute tragen über 300 Menschen unser Trikot — bei Marathons, Trailruns, Firmenläufen und auf einer Runde im Park, in ganz Europa, um M.E. bekannt zu machen und Spenden zu sammeln.',
  vision: 'Wir wünschen uns eine Zukunft, in der M.E. früh erkannt und richtig diagnostiziert wird und Betroffene zuverlässig versorgt werden — mit Behandlungen, die wirklich helfen.',
  personalStory1: 'Jede*r von ihnen macht eine Krankheit sichtbar, die 71 Millionen Menschen weltweit betrifft¹ — und die trotzdem kaum jemand kennt. Wir haben Freunde und Familie, die mit M.E. leben und nicht laufen können. Also laufen wir für sie.',
  personalStory2: 'Du brauchst keine Bestzeit. Du brauchst ein Trikot und einen Lauf.',
  impact: 'Deine Unterstützung finanziert Forschung zu den Ursachen und Behandlungen von M.E. und hilft Menschen, die mit dieser oft isolierenden Krankheit leben.',
  // Homepage spezifischer Inhalt
  hero: {
    title: 'Run for M.E.',
    subtitle: 'M.E. ist ein Marathon ohne Ziellinie.',
    tagline: 'Über 300 Läufer*innen in ganz Europa laufen für die, die es nicht können. Lauf mit.',
    buttons: {
      learnAboutME: 'Mehr über M.E.',
      viewTimeline: 'Läufe ansehen',
      joinUs: 'Mitlaufen & Trikot holen',
      supportCause: 'Unterstütze uns',
    },
    attribution: {
      photoBy: 'Foto von',
    },
  },
  stats: {
    shirtsValue: '300+',
    shirtsLabel: 'Trikots verteilt',
    // runsYear trennt auf der Läufe-Seite die aktuelle Saison von den bereits gelaufenen Läufen
    runsYear: '2026',
    runsLabel: 'Läufe seit 2025',
    countriesLabel: 'Länder',
    priceValue: '14 €',
    priceLabel: 'Selbstkostenpreis',
  },
  howItWorks: {
    title: 'So machst du mit',
    steps: [
      {
        number: '1',
        title: 'Sag uns Bescheid',
        description: 'Formular ausfüllen: welcher Lauf, welche Größe. Egal ob Marathon, 5 km oder eine Runde im Park.',
      },
      {
        number: '2',
        title: 'Trikot kommt per Post',
        description: '14 € — 10 € Produktion, 2 € Versand, 2 € Material. Wir verdienen nichts daran.',
      },
      {
        number: '3',
        title: 'Du läufst, wir feiern dich',
        description: 'Dein Lauf kommt auf unsere Liste. Dein Foto — wenn du magst — auf Instagram.',
      },
    ],
    button: 'Jetzt anmelden',
  },
  cards: {
    marathon: {
      title: 'Trikot holen & mitlaufen',
      description: '14 € zum Selbstkostenpreis, inklusive Versand und Flyer. Wir verdienen nichts daran — wir wollen nur, dass es draußen gesehen wird.',
    },
    research: {
      title: 'Such dir einen Lauf',
      description: 'Läufe quer durch Europa stehen auf unserer Liste — oder du bringst deinen eigenen mit. Jede Distanz zählt.',
    },
    awareness: {
      title: 'Spenden',
      description: 'Deine Spende geht über betterplace.org direkt an M.E.-Forschung und die Versorgung schwerstkranker Betroffener. Mit Spendenbescheinigung.',
    },
  },
  awareness: {
    title: 'M.E. sichtbar machen',
    subtitle: 'Erzähl fünf Menschen von M.E. Das ist schon ein Anfang.',
    description: 'M.E. betrifft Millionen Menschen — und trotzdem hat kaum jemand davon gehört. Genau das ist das Problem: Was niemand kennt, wird nicht erforscht, nicht diagnostiziert und nicht behandelt. Jedes Gespräch, jeder geteilte Beitrag und jedes Trikot auf einer Laufstrecke macht die Krankheit ein Stück sichtbarer.',
  },
  donation: {
    title: 'Spenden',
    subtitle: 'Deine Spende geht direkt an M.E.-Forschung und die Versorgung von Betroffenen.',
    impact: 'Wir sammeln über betterplace.org, Deutschlands größte Spendenplattform — transparent und mit Spendenbescheinigung. Jeder Betrag zählt: M.E.-Forschung ist so unterfinanziert, dass auch kleine Summen einen Unterschied machen.',
    supportButton: 'Jetzt spenden',
  },
  makeDifference: {
    title: 'Mach mit',
  },
  joinUs: {
    title: 'Lauf mit uns',
    subtitle: 'Egal welcher Lauf, egal welche Distanz.',
    description: 'Du läufst einen Lauf von unserer Liste oder einen ganz anderen? Du spielst Tennis, machst einen Triathlon oder gehst einfach sonntags joggen? Perfekt. Melde dich an, wir schicken dir dein Trikot und nehmen deinen Lauf in unsere Liste auf.',
    linkText: 'Zur Mitmachen-Seite',
    contactInfo: 'Oder schreib uns direkt: runforme.contact(at)gmail.com',
    floatingLabel: 'Mitlaufen',
  },
};

export const RUNNING_EVENTS_DE: RunningEvent[] = [
  {
    date: '8. März 2026',
    name: 'Bienwald Marathon Kandel',
    location: 'Kandel, Deutschland',
  },
  {
    date: '15. März 2026',
    name: 'Mammuthmarsch München',
    location: 'München, Deutschland',
  },
  {
    date: '22. März 2026',
    name: 'Rom Marathon',
    location: 'Rom, Italien',
  },
  {
    date: '29. März 2026',
    name: 'Berliner Halbmarathon',
    location: 'Berlin, Deutschland',
  },
  {
    date: '12. April 2026',
    name: 'ADAC Marathon Hannover',
    location: 'Hannover, Deutschland',
    distances: 'Marathon | Halbmarathon | Staffel | 10k',
  },
  {
    date: '18. April 2026',
    name: 'Leipzig Marathon',
    location: 'Leipzig, Deutschland',
    distances: 'Marathon | Halbmarathon | 4k & 10k Laufen/Walken',
  },
  {
    date: '19. April 2026',
    name: 'Deutsche Post Marathon Bonn',
    location: 'Bonn, Deutschland',
    distances: 'Marathon | Halbmarathon | Staffel | 10k',
  },
  {
    date: '19. April 2026',
    name: 'Vienna City Marathon',
    location: 'Wien, Österreich',
    distances: 'Marathon | Halbmarathon | Staffel',
  },
  {
    date: '26. April 2026',
    name: 'Düsseldorf Marathon',
    location: 'Düsseldorf, Deutschland',
    distances: 'Marathon | Halbmarathon | Staffel',
  },
  {
    date: '26. April 2026',
    name: 'Heidelberg Halbmarathon',
    location: 'Heidelberg, Deutschland',
  },
  {
    date: '26. April 2026',
    name: 'Hamburg Marathon',
    location: 'Hamburg, Deutschland',
    distances: 'Marathon | Halbmarathon | Staffel',
  },
  {
    date: '2. Mai 2026',
    name: 'Traunstein',
    location: 'Traunstein, Deutschland',
    distances: '12k | Halbmarathon',
  },
  {
    date: '9. Mai 2026',
    name: 'Gutenberg Halbmarathon Mainz',
    location: 'Mainz, Deutschland',
    distances: 'Halbmarathon',
  },
  {
    date: '10. Mai 2026',
    name: 'Kopenhagen Marathon',
    location: 'Kopenhagen, Dänemark',
  },
  {
    date: '13. Mai 2026',
    name: 'ASV Nachtlauf',
    location: 'Köln, Deutschland',
  },
  {
    date: '17. Mai 2026',
    name: 'Stuttgart Marathon',
    location: 'Stuttgart, Deutschland',
    distances: '5k | 10k | Halbmarathon | Staffel',
  },
  {
    date: '25. Mai 2026',
    name: 'Royal Run Kopenhagen',
    location: 'Kopenhagen, Dänemark',
    distances: '5k | 10k',
  },
  {
    date: '7. Juni 2026',
    name: 'ProPotsdam Schlösserlauf',
    location: 'Potsdam, Deutschland',
    distances: '10k | Halbmarathon',
  },
  {
    date: '10. Juni 2026',
    name: 'Unilauf Köln',
    location: 'Köln, Deutschland',
    distances: '2,5k | 5k | 10k',
  },
  {
    date: '13. Juni 2026',
    name: 'Tschirgant Skyrun',
    location: 'Imst, Österreich',
    distances: 'Trailrun',
  },
  {
    date: '19. Juni 2026',
    name: 'Mittsommerlauf Wallau',
    location: 'Wallau, Deutschland',
  },
  {
    date: '28. Juni 2026',
    name: 'Hamburg Halbmarathon',
    location: 'Hamburg, Deutschland',
  },
  {
    date: '28. Juni 2026',
    name: 'Trier Marathon',
    location: 'Trier, Deutschland',
    distances: 'Marathon',
  },
  {
    date: '1. Juli 2026',
    name: 'Lousberglauf Aachen',
    location: 'Aachen, Deutschland',
  },
  {
    date: '5. Juli 2026',
    name: 'München Sportscheck Run',
    location: 'München, Deutschland',
    distances: '5k | 10k | Halbmarathon',
  },
  {
    date: '11. Juli 2026',
    name: 'Rosengarten Skymarathon',
    location: 'Südtirol, Italien',
    distances: 'Skymarathon',
  },
  {
    date: '11. Juli 2026',
    name: '7-Täler Lauf Dietfurt',
    location: 'Dietfurt, Deutschland',
  },
  {
    date: '15. Juli 2026',
    name: 'Firmenlauf Friedrichshafen',
    location: 'Friedrichshafen, Deutschland',
  },
  {
    date: '1. August 2026',
    name: 'Adidas Runners City Night',
    location: 'Berlin, Deutschland',
    distances: '5k | 10k',
  },
  {
    date: '5. September 2026',
    name: 'Mammut Marsch Bremen',
    location: 'Bremen, Deutschland',
  },
  {
    date: '6. September 2026',
    name: 'Carglass Triathlon Köln',
    location: 'Köln, Deutschland',
    distances: 'Triathlon',
  },
  {
    date: '12. September 2026',
    name: 'WE&ME SeeStadtlauf',
    location: 'Wien, Österreich',
    distances: '5k | 10k',
  },
  {
    date: '12. September 2026',
    name: 'USee Run 2026',
    location: 'Düsseldorf, Deutschland',
  },
  {
    date: '13. September 2026',
    name: 'Münster Marathon',
    location: 'Münster, Deutschland',
    distances: 'Marathon',
  },
  {
    date: '20. September 2026',
    name: 'Baden Marathon Karlsruhe',
    location: 'Karlsruhe, Deutschland',
    distances: 'Marathon | Halbmarathon | Staffel',
  },
  {
    date: '04. Oktober 2026',
    name: 'Köln Marathon',
    location: 'Köln, Deutschland',
    distances: 'Marathon | Halbmarathon | Staffel',
  },
  {
    date: '11. Oktober 2026',
    name: 'Monopteroslauf München',
    location: 'München, Deutschland',
    distances: '5-33 km',
  },
  {
    date: '11. Oktober 2026',
    name: 'München Marathon',
    location: 'München, Deutschland',
    distances: 'Marathon | Halbmarathon | Staffel',
  },
  {
    date: '25. Oktober 2026',
    name: 'Frankfurt Marathon',
    location: 'Frankfurt, Deutschland',
    distances: 'Marathon | Staffel',
  },
  {
    date: '1. November 2026',
    name: 'New York City Marathon',
    location: 'New York, USA',
  },
  {
    date: '8. November 2026',
    name: 'Athen Marathon',
    location: 'Athen, Griechenland',
    distances: 'Marathon',
  },
  // 2025 – bereits gelaufen
  {
    date: 'Oktober 2025',
    name: 'Köln Marathon',
    location: 'Köln, Deutschland',
    distances: 'Marathon',
  },
  {
    date: 'September 2025',
    name: 'Berlin Marathon',
    location: 'Berlin, Deutschland',
    distances: 'Marathon',
  },
  {
    date: 'Oktober 2025',
    name: 'Lissabon Marathon',
    location: 'Lissabon, Portugal',
    distances: 'Marathon',
  },
];

// Running events page specific content
export const RUNNING_EVENTS_PAGE_DE = {
  title: 'Läufe',
  upcomingTitle: 'Läufe 2026',
  pastTitle: 'Läufe 2025',
  subtitle: 'Wir laufen verschiedene Läufe, um Aufklärung zu betreiben und Spenden für M.E. Forschung und Betroffenenhilfe zu sammeln',
  description: 'Diese Läufe stehen 2026 an. Such dir einen aus — oder bring deinen eigenen mit.',
  callToAction: {
    title: 'Lauf mit uns',
    description: 'Du läufst einen Lauf von dieser Liste oder einen ganz anderen? Melde dich an, wir schicken dir dein Trikot.',
    additionalInfo: 'Egal ob Marathon, 5 km, Trailrun oder eine Runde im Park: Jede Distanz zählt und jeder Lauf kommt auf unsere Liste. Wir freuen uns über jede*n, der mitmacht.',
    contactInfo: 'Oder schreib uns direkt: runforme.contact(at)gmail.com',
  },
};

export const ABOUT_US_DE = {
  title: 'Über uns',
  description: 'Angefangen haben wir zu dritt in Berlin. Inzwischen laufen über 300 Menschen in unserem Trikot — in Deutschland, Österreich und quer durch Europa.',
  why: {
    personalConnection: {
      title: 'Persönliche Verbindung',
      content: 'Wir haben Freunde, die M.E. haben und nicht selbst laufen können. Wir haben unser ganzes Leben lang Sport gemacht — und dabei gelernt, dass Gesundheit nichts Selbstverständliches ist. Menschen mit M.E. bleiben meist unsichtbar und missverstanden. Genau das wollen wir ändern.'
    },
    mission: {
      title: 'Unsere Mission',
      content: 'Niemand sollte im Stillen leiden. M.E. ist eine schwere Erkrankung, die Aufmerksamkeit, Forschung und Unterstützung verdient. Jedes Trikot auf einer Laufstrecke ist ein sichtbares Zeichen dafür — und eine Stimme für die, die selbst nicht laufen können.'
    }
  },
  team: {
    title: 'Unser Team',
    imageAlt: 'Unser Team - Rebecca, Valentina und Felicitas',
    description: 'Unser Team aus Läufer*innen, die sich für M.E.-Forschung, Spenden und Aufklärung einsetzen.',
    members: [
      {
        name: 'Rebecca',
        role: 'Partnerschaften',
        description: 'Rebecca knüpft Kooperationen und Partnerschaften, damit unsere Botschaft mehr Menschen erreicht.',
        imageSrc: '/Rebecca.JPG',
        imageAlt: 'Porträt von Rebecca',
      },
      {
        name: 'Valentina',
        role: 'Design',
        description: 'Valentina gestaltet die visuelle Identität und die Design-Materialien für Run for M.E.',
        imageSrc: '/Vale.png',
        imageAlt: 'Porträt von Valentina',
      },
      {
        name: 'Felicitas',
        role: 'Instagram',
        description: 'Felicitas betreut unseren Instagram-Auftritt und teilt Updates sowie Awareness-Content.',
        imageSrc: '/Lici.png',
        imageAlt: 'Porträt von Lici',
      },
    ],
  },
  joinOurCause: {
    title: 'Werde Teil davon',
    description: 'Wir suchen Menschen, die in unserem Trikot an den Start gehen — bei einem Lauf von unserer Liste oder bei deinem eigenen.',
    additionalInfo: 'Ob du läufst, spendest, unsere Geschichte teilst oder eine eigene Idee mitbringst: Alles hilft, M.E. sichtbarer zu machen. Schreib uns einfach.',
  },
};

// Mitmachen-Seite – Kontakt und Mitmachen
export const MITMACHEN_DE = {
  title: 'Mitlaufen & Trikot holen',
  subtitle:
    'Über 300 Menschen laufen schon in unserem Trikot. Melde dich an, wir schicken dir deins für 14 € zum Selbstkostenpreis — und nehmen deinen Lauf in unsere Liste auf. Egal welche Distanz.',
  email: {
    label: 'E-Mail',
    address: 'runforme.contact(at)gmail.com',
    mailto: 'runforme.contact@gmail.com',
    description: 'Schreib uns bei Fragen zu Läufen, Kooperationen oder wie du mitmachen kannst.',
  },
  instagram: {
    title: 'Folge uns auf Instagram',
    description: 'Trainings-Updates, M.E.-Aufklärung und Einblicke hinter die Kulissen.',
    button: 'Folge @runformecfs',
  },
  form: {
    title: 'Jetzt anmelden',
    infoTitle: 'So funktioniert es',
    infoText: [
      'Wir suchen Läufer*innen und Sportler*innen weltweit – mit jedem Lauf, jeder Distanz oder jedem Sportevent – die Lust haben, mit unserem T-Shirt anzutreten und so auf M.E. aufmerksam zu machen. Wir nehmen den Lauf in unsere Liste auf der Webseite auf und laden – falls einverstanden – Fotos auf Instagram hoch. Das Motto: je mehr Sportler*innen mitmachen, desto besser.',
      'Natürlich können auch T-Shirts bestellt werden ohne Anmeldung bei offiziellen Läufen. Im Sinne eines „Move for M.E.“ freuen wir uns über das Tragen unserer T-Shirts beim Freizeitlauf im Park, bei Tennistunieren oder sonstigen Anlässen jeglicher Art!',
      'Jedem, der mitmacht, schicken wir unser T-Shirt sowie Flyer für 14 €  (10 € Produktionspreis + 2 € Versand innerhalb Deutschlands + 2€ weitere Materialkosten), und bitten darum, das Projekt im Freundes- und Bekanntenkreis zu teilen, um weitere Sportler*innen zu finden sowie auf M.E. aufmerksam zu machen.',
      'Für größere Aktionen oder weitere Ideen sind wir auch sehr offen. Spenden für M.E. Forschung und Versorgung sammeln wir zusätzlich über den Link auf unserer Webseite für die dort angegebenen Projekte.',
      'Wenn du mehr T-Shirts bestellen möchtest oder andere Ideen für Aktionen hast, schreib uns einfach per E-Mail: runforme.contact(at)gmail.com.',
    ],
    paymentInfo: 'Zahlung erfolgt per PayPal vor Versand. T-Shirts werden regelmäßig nachbestellt – je nach Lagerbestand kann die Lieferzeit etwas variieren. Bei Fragen meldet euch gerne bei uns.',
    material: 'Material: Funktions-T-Shirt aus 100 % Polyester, Unisex-Schnitt.',
    fields: {
      name: 'Vollständiger Name',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer (optional – für unsere WhatsApp-Gruppe)',
      address: 'Postadresse für den T-Shirt-Versand',
      run: 'An welchem Lauf oder Sportevent nimmst du teil? (optional)',
      runDate: 'Datum des Laufes / Wann benötigst du das T-Shirt? (optional)',
      size: 'T-Shirt-Größe (Unisex)',
      howHeard: 'Wo hast du von uns gehört? (optional)',
      notes: 'Notizen zu deiner Teilnahme (optional)',
    },
    sizeOptions: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
    outOfStock: [],
    outOfStockLabel: 'längere Lieferzeit',
    outOfStockHelper: 'Hinweis: Diese Größe ist aktuell nicht auf Lager – du kannst sie trotzdem bestellen, die Lieferung kann nur etwas länger dauern.',
    infoShowMore: 'Mehr lesen',
    infoShowLess: 'Weniger anzeigen',
    consentText:
      'Wir verarbeiten deine Daten, um deine Bestellung abzuwickeln, das T-Shirt zu versenden und dich zu deinem Lauf zu kontaktieren.',
    consentLinkText: 'Mehr dazu in der Datenschutzerklärung',
    withdrawal: {
      title: 'Dein Widerrufsrecht',
      text: 'Du kannst deine Bestellung innerhalb von 14 Tagen ab Erhalt des T-Shirts ohne Angabe von Gründen widerrufen — eine formlose E-Mail an runforme.contact(at)gmail.com genügt. Wir erstatten dir dann den vollen Betrag inklusive Versandkosten; die Kosten der Rücksendung trägst du.',
      linkText: 'Vollständige Widerrufsbelehrung im Impressum',
    },
    submitHint: 'Damit bestellst du dein T-Shirt für 14 € und wirst Teil der Community.',
    submit: 'Zahlungspflichtig bestellen',
    submitting: 'Wird bestellt…',
    success: {
      title: 'Bestellung eingegangen!',
      text: 'Vielen Dank für deine Bestellung bei Run for M.E.! Wir melden uns bald bei dir und schicken dir dein T-Shirt und Flyer zu.',
    },
    error: 'Leider ist etwas schiefgelaufen. Bitte versuche es erneut oder schreib uns direkt an runforme.contact@gmail.com.',
    errors: {
      required: 'Dieses Feld ist erforderlich.',
      email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    },
  },
};

export const SOCIAL_MEDIA_DE = {
  instagram: {
    handle: '@runformecfs',
    url: 'https://www.instagram.com/runformecfs/',
    description: 'Folge unserem Weg auf Instagram: Läufe, Trikots in freier Wildbahn, M.E.-Aufklärung und Blicke hinter die Kulissen.',
  },
  // Instagram page specific content (used on Mitmachen page)
  page: {
    title: 'Folge unserem Weg',
    subtitle: 'Läufe, Trikots in freier Wildbahn und M.E.-Aufklärung — direkt aus der Community.',
    feed: {
      title: 'Instagram Feed',
      description: 'Unsere neuesten Beiträge und Updates von Instagram',
      placeholder: {
        title: 'Instagram Feed',
        description: 'Folge uns auf Instagram und sieh, wo unser Trikot gerade unterwegs ist.',
        button: 'Instagram-Profil ansehen',
      },
    },
    callToAction: {
      title: 'Bleib dabei',
      description: 'Auf Instagram posten wir die Läufe unserer Community, Fotos aus dem Zielbereich und alles rund um M.E.-Aufklärung.',
      additionalInfo: 'Teile unsere Beiträge — jeder Like, jeder Kommentar und jedes Teilen bringt M.E. vor mehr Augen. Genau darum geht es.',
      button: 'Folge @runformecfs',
    },
  },
};

export const DONATION_INFO_DE = {
    title: 'Spenden für M.E.',
    subtitle: 'Deine Spende geht direkt an M.E.-Forschung und die Versorgung von Betroffenen',
    mainDonationButton: {
      title: 'Jetzt spenden',
      description: 'Unterstütze unsere Lauf-Spendenaktion für M.E.',
      url: 'https://www.betterplace.org/de/fundraising-events/55788-run-for-me-cfs',
    },
    betterplaceDisclaimer: {
      title: 'Unsere Zusammenarbeit mit betterplace.org',
      text: 'Wir kooperieren mit der non-profit Plattform betterplace.org. Betterplace.org ist Deutschlands größte Spendenplattform und sichert Transparenz und Sicherheit der Spenden. Es ermöglicht uns auch die Ausstellung einer Spendenbescheinigung.',
    },
    impactSection: {
      title: 'Warum deine Unterstützung wichtig ist',
      cards: [
        {
            title: 'Schwerwiegendste chronische Erkrankung',
            description: 'M.E. gilt als eine der schwerwiegendsten chronischen Erkrankungen, mit einer Lebensqualität, die schlechter ist als bei vielen anderen Erkrankungen, die 71 Millionen Menschen weltweit betreffen¹⁴.',
        },
        {
          title: 'Forschungs-finanzierungslücke',
          description: 'Die aktuelle Forschungsfinanzierung in Deutschland beträgt nur etwa 15 Millionen Euro für ein 3-jähriges M.E. Forschungsprogramm⁶ - ein Bruchteil dessen, was andere chronische Erkrankungen erhalten.',
        },
        {
            title: 'Wirtschaftliche Auswirkungen',
            description: 'M.E. (und Long COVID) kostet Deutschland jährlich etwa 1,5% des BIP² - eine verheerende wirtschaftliche Belastung, die alle betrifft.',
          },
      ],
    },
    learnMore: {
      title: 'Erfahre mehr über M.E.',
      subtitle: 'Willst du verstehen, was es bedeutet, mit M.E. zu leben?',
      button: 'Zur M.E. Infoseite',
    },
    // Donation call to action in Fundraiser Info page section
  causes: [
    {
      title: 'Forschungsfinanzierung für M.E.',
      description: 'Wir unterstützen die ME Research Foundation bei der Finanzierung neuer Forschungsprojekte zur Verbesserung des Verständnisses und Behandlung von M.E.',
      details: 'Deine Spenden finanzieren Forschung zu Biomarkern und Mechanismen von M.E. Die Forschung zielt darauf ab, diagnostische Werkzeuge zu identifizieren und evidenzbasierte Behandlungen für diese komplexe neuroimmunologische Erkrankung zu entwickeln.',
    },
    {
      title: 'Virtuelle Medizinische Versorgung',
      description: 'Unterstützung von virtuellen Sprechstunden für schwerstkranke M.E. Betroffene, die keinen Zugang zu traditioneller medizinischer Versorgung haben.',
      details: 'Dieses Projekt von der Lost Voices Foundation bietet spezialisierte virtuelle medizinische Beratungen für bettlägerige Patienten, einschließlich Symptommanagement, Medikamentenüberprüfungen und Koordination mit lokalen Gesundheitsdienstleistern.',
    },
  ],
};

// Rechtliche Inhalte für Deutsch
export const LEGAL_CONTENT_DE = {
  impressum: {
    title: 'Impressum',
    contact: {
      title: 'Angaben gemäß § 5 DDG',
      description: 'Diese Website wird von einer Privatperson im Rahmen einer persönlichen Aufklärungs- und Fundraising-Initiative betrieben.',
    },
    purpose: {
      title: 'Zweck der Website',
      description: 'Diese Website dient der Aufklärung über M.E./CFS, der Vermittlung von Spenden an die genannten Forschungsprojekte sowie der Abgabe unserer T-Shirts zum Selbstkostenpreis. Es handelt sich um eine private Initiative ohne Gewinnerzielungsabsicht und nicht um eine eingetragene Organisation oder gemeinnützige Einrichtung.',
      goal: 'Das Ziel ist die Sammlung von Spenden für die Erforschung von Myalgischer Enzephalomyelitis/Chronischem Erschöpfungssyndrom (M.E./CFS) und die Aufklärung über diese Erkrankung.',
    },
    shirts: {
      title: 'T-Shirts zum Selbstkostenpreis',
      description: 'Wer sich über das Formular auf der Seite „Mitmachen“ anmeldet, erhält von uns ein T-Shirt und Flyer zum Selbstkostenpreis von 14 € (10 € Produktion, 2 € Versand innerhalb Deutschlands, 2 € weiteres Material). Wir erzielen damit keinen Gewinn — der Betrag deckt ausschließlich die uns entstehenden Kosten. Auch wenn wir ohne Gewinnerzielungsabsicht handeln, gelten für diese Bestellungen die gesetzlichen Verbraucherrechte; die folgenden Angaben gelten für alle Bestellungen von Verbraucherinnen und Verbrauchern.',
      price: {
        title: 'Preis und Zahlung:',
        text: 'Der genannte Preis von 14 € ist ein Gesamtpreis einschließlich Versand innerhalb Deutschlands. Umsatzsteuer wird nicht gesondert ausgewiesen. Die Zahlung erfolgt per PayPal vor dem Versand. Für den Versand ins Ausland gelten abweichende Versandkosten — bitte sprechen Sie uns vorab per E-Mail an.',
      },
      contract: {
        title: 'Vertragsschluss und Lieferung:',
        text: 'Mit dem Absenden des Anmeldeformulars geben Sie eine verbindliche Bestellung ab. Der Vertrag kommt mit unserer Bestätigung per E-Mail zustande. T-Shirts werden regelmäßig nachbestellt; je nach Lagerbestand kann die Lieferzeit variieren. Der Vertragstext wird von uns nicht gesondert gespeichert und veröffentlicht; Ihre Bestelldaten erhalten Sie per E-Mail.',
      },
      withdrawal: {
        title: 'Widerrufsrecht:',
        text: 'Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Ware in Besitz genommen haben bzw. hat. Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Kontaktdaten siehe oben) mittels einer eindeutigen Erklärung — zum Beispiel per E-Mail — über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.',
      },
      withdrawalConsequences: {
        title: 'Folgen des Widerrufs:',
        text: 'Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist. Wir können die Rückzahlung verweigern, bis wir die Ware zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Ware zurückgesandt haben — je nachdem, welches der frühere Zeitpunkt ist. Sie haben die Ware unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf unterrichten, an uns zurückzusenden. Die unmittelbaren Kosten der Rücksendung tragen Sie. Sie müssen für einen etwaigen Wertverlust der Ware nur aufkommen, wenn dieser auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Ware nicht notwendigen Umgang mit ihr zurückzuführen ist.',
      },
      warranty: {
        title: 'Gewährleistung:',
        text: 'Es gelten die gesetzlichen Mängelrechte (§§ 434 ff. BGB). Bei einem Mangel melden Sie sich bitte per E-Mail bei uns — wir tauschen das T-Shirt um oder erstatten den Betrag.',
      },
      dispute: {
        title: 'Streitbeilegung:',
        text: 'Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
      },
    },
    disclaimer: {
      title: 'Haftungsausschluss',
      content: {
        title: 'Inhaltliche Verantwortung:',
        text: 'Die bereitgestellten Informationen dienen ausschließlich Bildungs- und Fundraising-Zwecken. Es wird keine Garantie für die Richtigkeit medizinischer Informationen gegeben. Für medizinische Fragen wenden Sie sich bitte an qualifizierte Ärzte.',
      },
      external: {
        title: 'Externe Links:',
        text: 'Diese Website enthält Links zu externen Websites. Die jeweiligen Anbieter sind für den Inhalt dieser externen Websites verantwortlich. Wir haben keinen Einfluss auf deren Inhalt und übernehmen keine Haftung dafür.',
      },
      donations: {
        title: 'Spenden:',
        text: 'Alle Spenden werden direkt an die angegebenen Forschungsorganisationen weitergeleitet. Wir sind nicht verantwortlich für die Verwendung der Spenden durch diese Organisationen oder deren Forschungsergebnisse.',
      },
    },
    copyright: {
      title: 'Urheberrecht',
      description: 'Der Inhalt dieser Website ist urheberrechtlich geschützt. Die Nutzung von Texten, Bildern oder anderem Inhalt ist nur mit ausdrücklicher Zustimmung gestattet.',
      images: 'Bildquellen: Alle verwendeten Bilder stammen aus lizenzfreien Quellen oder wurden mit entsprechenden Rechten verwendet.',
    },
    additional: {
      title: 'Weitere rechtliche Informationen',
      links: 'Datenschutzerklärung | Cookie-Erklärung',
    },
  },
  privacy: {
    title: 'Datenschutzerklärung',
    responsible: {
      title: '1. Verantwortlicher für die Datenverarbeitung',
      description: 'Verantwortlich für die Datenverarbeitung auf dieser Website:',
    },
    general: {
      title: '2. Allgemeine Hinweise zur Datenverarbeitung',
      description: 'Diese Website dient der Aufklärung über M.E./CFS, der Vermittlung von Spenden an Forschungsprojekte sowie der Abgabe unserer T-Shirts zum Selbstkostenpreis. Es handelt sich um eine private Initiative ohne Gewinnerzielungsabsicht.',
      principle: 'Grundsatz: Wir erheben und verarbeiten nur die Daten, die für den Betrieb der Website, für die Bearbeitung Ihrer Bestellung und — soweit Sie eingewilligt haben — für die Reichweitenmessung erforderlich sind. Es findet keine Profilbildung und keine Weitergabe zu Werbezwecken statt.',
    },
    automatic: {
      title: '3. Automatisch erfasste Daten',
      server: {
        title: 'Server-Logfiles:',
        description: 'Diese Website wird bei Netlify (Netlify, Inc., 512 2nd Street, San Francisco, CA 94107, USA) gehostet. Bei jedem Zugriff werden automatisch folgende Daten in Server-Logfiles erfasst:',
        data: [
          'IP-Adresse des zugreifenden Rechners',
          'Datum und Uhrzeit des Zugriffs',
          'Name und URL der abgerufenen Datei',
          'Übertragene Datenmenge',
          'Meldung über erfolgreichen Abruf',
          'Browsertyp und -version',
          'Betriebssystem des Nutzers',
        ],
      },
      analytics: {
        title: 'Google Analytics:',
        description: 'Diese Website verwendet Google Analytics 4 (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland) zur Reichweitenmessung. Google Analytics wird ausschließlich geladen, nachdem Sie im Cookie-Banner eingewilligt haben — ohne Einwilligung findet keinerlei Analyse statt. Google-Signals und Ad-Personalisierung sind deaktiviert, IP-Adressen werden gekürzt und nicht gespeichert. Eine Übermittlung in die USA an Google LLC kann nicht ausgeschlossen werden; Google ist unter dem EU-US Data Privacy Framework zertifiziert. Dabei werden verarbeitet:',
        data: [
          'IP-Adresse (anonymisiert)',
          'Besuchte Seiten und Verweildauer',
          'Verweisquelle (wie Sie auf die Website gekommen sind)',
          'Browser- und Geräteinformationen',
          'Geografische Standortdaten (Land/Stadt)',
        ],
        legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)',
        retention: 'Speicherdauer: 26 Monate (Google Analytics Standard)',
        optout: 'Opt-out: Sie können Google Analytics über Browser-Einstellungen oder Google Analytics Opt-out Browser Add-on deaktivieren.',
      },
      legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technischen Funktionsfähigkeit und Sicherheit der Website). Die Verarbeitung findet auch in den USA statt; Netlify ist unter dem EU-US Data Privacy Framework zertifiziert und wir haben mit Netlify einen Auftragsverarbeitungsvertrag samt EU-Standardvertragsklauseln geschlossen.',
      retention: 'Speicherdauer: Die Logfiles werden von Netlify nur kurzzeitig zur Sicherstellung des Betriebs vorgehalten und automatisch gelöscht. Wir werten sie nicht personenbezogen aus.',
    },
    cookies: {
      title: '4. Cookies',
      necessary: {
        title: 'Einstellungen im lokalen Speicher:',
        description: 'Diese Website speichert Ihre Sprachwahl und Ihre Cookie-Entscheidung im lokalen Speicher Ihres Browsers (localStorage, Einträge „language“ und „cookieConsent“). Diese Einträge werden erst gesetzt, nachdem Sie im Cookie-Banner zugestimmt haben, verbleiben ausschließlich auf Ihrem Gerät und werden nicht an uns übertragen.',
      },
      analytics: {
        title: 'Analyse-Cookies (Google Analytics):',
        description: 'Nach Ihrer Einwilligung setzt Google Analytics Cookies, um die Nutzung der Website zu analysieren. Ohne Ihre Einwilligung wird Google Analytics nicht geladen und es werden keine Analyse-Cookies gesetzt.',
        legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG (Einwilligung)',
        optout: 'Opt-out: Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft in den Cookie-Einstellungen widerrufen.',
      },
      tracking: {
        title: 'Keine Marketing-Cookies:',
        description: 'Es werden keine Marketing- oder Werbe-Cookies verwendet. Es findet keine Profilbildung und keine geräteübergreifende Nutzerverfolgung statt; Google Signals und Ad-Personalisierung sind deaktiviert.',
      },
      legal: 'Rechtsgrundlage: Für die Speicherung im lokalen Speicher und für Analyse-Cookies Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG (Einwilligung).',
    },
    external: {
      title: '5. Externe Links und Dienste',
      forms: {
        title: 'Anmeldeformular (Netlify Forms und Google Sheets)',
        description:
          'Wenn Sie das Anmeldeformular („Mitmachen“) absenden, verarbeiten wir die von Ihnen eingegebenen Daten (Name, E-Mail-Adresse, Postadresse, ggf. Telefonnummer, Lauf, T-Shirt-Größe, Notizen), um Ihre Bestellung zu bearbeiten, das T-Shirt zu versenden und Ihren Lauf in unsere Liste aufzunehmen. Die Einsendung wird von Netlify (Netlify Forms) gespeichert und zusätzlich in eine Tabelle bei Google übertragen (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland), die wir als interne Teilnehmendenliste führen. Eine Weitergabe an weitere Dritte findet nicht statt — mit Ausnahme des Versanddienstleisters, der Ihre Adresse für die Zustellung benötigt.',
        legal:
          'Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Erfüllung des Kaufvertrags und vorvertragliche Maßnahmen). Die Angabe von Name und Adresse ist für den Versand erforderlich; ohne diese Angaben können wir die Bestellung nicht ausführen. Die übrigen Felder sind freiwillig.',
        retention:
          'Speicherdauer: Wir speichern Einsendungen so lange, wie es für Bearbeitung, Versand und Rückfragen erforderlich ist. Soweit wir zur Aufbewahrung von Belegen verpflichtet sind, bewahren wir die betreffenden Daten bis zum Ablauf der steuerlichen Aufbewahrungsfristen (§ 147 AO) auf und löschen sie danach.',
      },
      payment: {
        title: 'Zahlung (PayPal):',
        description:
          'Die Bezahlung der T-Shirts erfolgt über PayPal (PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, 2449 Luxemburg). Dabei verarbeitet PayPal Ihre Zahlungsdaten in eigener Verantwortung; wir erhalten von PayPal lediglich die Information über den Zahlungseingang sowie den von Ihnen dort hinterlegten Namen. Es gelten die Datenschutzbestimmungen von PayPal.',
        legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Erfüllung des Kaufvertrags).',
      },
      donations: {
        title: 'Spenden-Links:',
        description: 'Diese Website enthält Links zu externen Spendenplattformen und Forschungsorganisationen. Diese externen Anbieter sind für die Verarbeitung Ihrer Daten auf ihren Websites verantwortlich. Bitte beachten Sie deren jeweilige Datenschutzerklärungen.',
      },
      social: {
        title: 'Soziale Medien:',
        description: 'Links zu sozialen Medien führen zu externen Plattformen. Die Datenschutzbestimmungen dieser Plattformen gelten für die Nutzung ihrer Dienste.',
      },
    },
    rights: {
      title: '6. Ihre Rechte als betroffene Person',
      description: 'Sie haben folgende Rechte nach der DSGVO:',
      list: [
        'Auskunftsrecht (Art. 15 DSGVO)',
        'Recht auf Berichtigung (Art. 16 DSGVO)',
        'Recht auf Löschung (Art. 17 DSGVO)',
        'Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)',
        'Recht auf Datenübertragbarkeit (Art. 20 DSGVO)',
        'Widerspruchsrecht (Art. 21 DSGVO)',
        'Recht, eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO)',
      ],
      contact: 'Kontakt: Für die Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter der oben genannten E-Mail-Adresse. Eine automatisierte Entscheidungsfindung einschließlich Profiling nach Art. 22 DSGVO findet nicht statt.',
    },
    complaint: {
      title: '7. Beschwerderecht bei der Aufsichtsbehörde',
      description: 'Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren. Die für uns zuständige Aufsichtsbehörde ist:',
      authority: 'Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)',
      address: 'Promenade 27',
      city: '91522 Ansbach',
      email: 'E-Mail: poststelle(at)lda.bayern.de',
    },
    changes: {
      title: '8. Änderungen dieser Datenschutzerklärung',
      description: 'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen oder bei Änderungen unserer Website anzupassen. Die jeweils aktuelle Version ist auf dieser Website verfügbar.',
    },
  },
  cookies: {
    title: 'Cookie-Erklärung',
    what: {
      title: 'Was sind Cookies?',
      description: 'Cookies sind kleine Textdateien, die beim Besuch einer Website auf Ihrem Computer oder mobilen Gerät gespeichert werden. Sie helfen dabei, die Website zu verbessern und Ihnen eine bessere Nutzererfahrung zu bieten.',
    },
    which: {
      title: 'Welche Cookies verwendet diese Website?',
      preferences: {
        title: 'Einstellungen im lokalen Speicher:',
        description: 'Diese Website speichert Ihre Sprachwahl und Ihre Cookie-Entscheidung im lokalen Speicher Ihres Browsers (localStorage). Diese Einträge werden nur mit Ihrer ausdrücklichen Zustimmung gesetzt, verbleiben auf Ihrem Gerät und werden nicht an uns übertragen. Eigene Cookies setzt diese Website nicht.',
      },
      analytics: {
        title: 'Analyse-Cookies (Google Analytics):',
        description: 'Nach Ihrer Einwilligung setzt Google Analytics Cookies, um die Nutzung der Website zu analysieren. Ohne Ihre Einwilligung wird Google Analytics nicht geladen und es werden keine Analyse-Cookies gesetzt.',
      },
      tracking: {
        title: 'Keine Marketing-Cookies:',
        description: 'Es werden keine Marketing- oder Tracking-Cookies verwendet. Es findet keine Profilbildung oder Nutzerverfolgung statt.',
      },
    },
    detailed: {
      title: 'Detaillierte Cookie-Liste',
      preferences: {
        title: 'Einträge im lokalen Speicher',
        language: {
          title: 'Spracheinstellung (localStorage)',
          purpose: 'Zweck: Speichert Ihre bevorzugte Sprache (Englisch oder Deutsch) für die Website',
          duration: 'Speicherdauer: Bis zur manuellen Löschung oder Löschung der Browserdaten',
          legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG (Einwilligung)',
          optout: 'Opt-out: Sie können die Sprache in der Kopfzeile ändern oder Browserdaten löschen. Wenn Sie Cookies ablehnen, wird die Spracheinstellung nicht gespeichert.',
        },
        consent: {
          title: 'Cookie-Zustimmung (localStorage)',
          purpose: 'Zweck: Merkt sich Ihre Cookie-Zustimmung, um das Banner nicht wiederholt anzuzeigen',
          duration: 'Speicherdauer: Bis zur manuellen Löschung oder Löschung der Browserdaten',
          legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG (Einwilligung)',
          optout: 'Opt-out: Sie können Browserdaten löschen, um die Wahl zurückzusetzen. Wenn Sie Cookies ablehnen, werden keine Zustimmungsdaten gespeichert.',
        },
      },
      analytics: {
        title: 'Analyse-Cookies',
        googleAnalytics: {
          title: 'Analyse-Cookies (Google Analytics)',
          purpose: 'Zweck: Analysiert die Website-Nutzung, um zu verstehen, wie Besucher unsere Website nutzen',
          duration: 'Speicherdauer: 26 Monate (Google Analytics Standard)',
          legal: 'Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG (Einwilligung)',
          optout: 'Opt-out: Sie können Ihre Einwilligung jederzeit in den Cookie-Einstellungen widerrufen.',
        },
      },
    },
    decline: {
      title: 'Was passiert, wenn Sie Cookies ablehnen?',
      description: 'Wenn Sie Cookies ablehnen, speichern wir keine Daten in Ihrem Browser-LocalStorage. Das bedeutet:',
      effects: [
        'Ihre Spracheinstellung wird nicht gespeichert und wird bei jedem Besuch auf Englisch zurückgesetzt',
        'Das Cookie-Zustimmungsbanner wird bei Ihrem nächsten Besuch wieder angezeigt',
        'Sie können alle Website-Funktionen normal nutzen',
        'Es werden keine personenbezogenen Daten gesammelt oder gespeichert',
      ],
      note: 'Hinweis: Wenn Sie ablehnen, werden weder Cookies gesetzt noch Einträge im lokalen Speicher angelegt. Die Website funktioniert vollständig — sie merkt sich lediglich nichts von Besuch zu Besuch.',
    },
    manage: {
      title: 'Wie können Sie Cookies verwalten?',
      browser: {
        title: 'Browser-Einstellungen:',
        description: 'Sie können Cookies und lokale Speicherung in Ihren Browser-Einstellungen verwalten. Dort können Sie Cookies löschen oder die Cookie-Speicherung einschränken.',
      },
      note: {
        title: 'Hinweis:',
        description: 'Das Deaktivieren technisch notwendiger Cookies kann dazu führen, dass diese Website nicht mehr ordnungsgemäß funktioniert. Spracheinstellungen und Cookie-Zustimmung werden zurückgesetzt.',
      },
      instructions: {
        title: 'Anweisungen für gängige Browser:',
        list: [
          'Chrome: Einstellungen → Datenschutz und Sicherheit → Cookies und andere Websitedaten',
          'Firefox: Einstellungen → Datenschutz & Sicherheit → Cookies und Websitedaten',
          'Safari: Einstellungen → Datenschutz → Cookies und Websitedaten',
          'Edge: Einstellungen → Cookies und Websiteberechtigungen → Cookies',
        ],
      },
    },
    external: {
      title: 'Externe Cookies',
      donations: {
        title: 'Spenden-Links:',
        description: 'Wenn Sie auf Links zu externen Spendenplattformen klicken, können diese Websites ihre eigenen Cookies setzen. Diese unterliegen den Datenschutzrichtlinien der jeweiligen Anbieter.',
      },
      social: {
        title: 'Soziale Medien:',
        description: 'Links zu sozialen Medien können auch Cookies setzen, wenn Sie diese Dienste nutzen.',
      },
    },
    contact: {
      title: 'Kontakt',
      description: 'Wenn Sie Fragen zu Cookies oder Datenverarbeitung auf dieser Website haben, kontaktieren Sie uns gerne:',
      email: 'E-Mail: runforme.contact(at)gmail.com',
    },
  },
  cookieBanner: {
    title: 'Cookie-Einstellungen',
    description: 'Diese Website verwendet Cookies, um die ordnungsgemäße Funktionalität zu gewährleisten und die Nutzung der Website zu analysieren. Sie können Ihre Einstellungen anpassen.',
    tracking: 'Für detaillierte Informationen über Cookies und Datenverarbeitung siehe unsere',
    cookiePolicy: 'Cookie-Erklärung',
    privacyPolicy: 'Datenschutzerklärung',
    settings: 'Einstellungen',
    acceptAll: 'Alle akzeptieren',
  },
};

export const CONTENT_DE = {
  meInfo: ME_INFO_DE,
  fundraiserInfo: FUNDRAISER_INFO_DE,
  runningEvents: RUNNING_EVENTS_DE,
  runningEventsPage: RUNNING_EVENTS_PAGE_DE,
  aboutUs: ABOUT_US_DE,
  socialMedia: SOCIAL_MEDIA_DE,
  mitmachen: MITMACHEN_DE,
  donationInfo: DONATION_INFO_DE,
  legal: LEGAL_CONTENT_DE,
  citations: CITATIONS_DE,
};
